import { styled } from '@mui/material/styles';

export const StyledImage = styled('img')({
  display: 'block',
  maxWidth: '100%',
  // height: 'auto',
});
